import { AnalyzeID } from "../../survey";

export type IDFieldData = {
  [key: string]: {
    value?: string;
    confidence?: number;
    normalizedValue?: {
      Value?: string;
      ValueType?: string;
    }
  } | undefined
}

/**
 * Keys available in the analyzeOutputSchema:
 * - address: Combined address information
 * - street: Street address
 * - city: City name
 * - state: State/province
 * - zip: ZIP/postal code
 * - country: Country name
 * - legal_name: Combined full name
 * - first_name: First/given name
 * - last_name: Last/family name
 * - middle_name: Middle name
 * - birth_date: Date of birth
 * - document_number: ID document number
 * - document_type: Type of ID document
 * - expiration_date: Document expiration date
 * - issued_date: Document issue date
 *
 * These will all be saved to [tpc_target_field]_key
 * e.g. analyze_id_zip, analyze_id_first_name, etc
 */
export const analyzeOutputSchema: Record<keyof Required<AnalyzeID>["autoUnrollKeys"], (results: IDFieldData) => string | undefined> = {
  "address": (results: IDFieldData) => [results.ADDRESS?.value, 
    results.CITY_IN_ADDRESS?.value, 
    [results.STATE_IN_ADDRESS?.value, results.ZIP_CODE_IN_ADDRESS?.value].filter(Boolean).join(" "),
    results.COUNTRY_IN_ADDRESS?.value
  ].filter(Boolean).join(", "),
  "street": (results: IDFieldData) => results.ADDRESS?.value,
  "city": (results: IDFieldData) => results.CITY_IN_ADDRESS?.value,
  "state": (results: IDFieldData) => results.STATE_IN_ADDRESS?.value,
  "zip": (results: IDFieldData) => results.ZIP_CODE_IN_ADDRESS?.value,
  "country": (results: IDFieldData) => results.COUNTRY_IN_ADDRESS?.value,
  "legal_name": (results: IDFieldData) => [results.FIRST_NAME?.value,
    results.MIDDLE_NAME?.value,
    results.LAST_NAME?.value
  ].filter(Boolean).join(" "),
  "first_name": (results: IDFieldData) => results.FIRST_NAME?.value,
  "last_name": (results: IDFieldData) => results.LAST_NAME?.value,
  "middle_name": (results: IDFieldData) => results.MIDDLE_NAME?.value,
  "birth_date": (results: IDFieldData) => results.DATE_OF_BIRTH?.value,
  "document_number": (results: IDFieldData) => results.DOCUMENT_NUMBER?.value,
  "document_type": (results: IDFieldData) => results.ID_TYPE?.value,
  "expiration_date": (results: IDFieldData) => results.EXPIRATION_DATE?.value,
  "issued_date": (results: IDFieldData) => results.DATE_OF_ISSUE?.value,
}